import _defineProperty from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { withScope, captureException, showReportDialog } from '@sentry/browser';
import { isError, logger } from '@sentry/utils';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";

function isAtLeastReact17(version) {
  var major = version.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}

var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ErrorBoundary.prototype.__init.call(_assertThisInitialized(_this));

    ErrorBoundary.prototype.__init2.call(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "__init",
    value: function __init() {
      this.state = INITIAL_STATE;
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, _ref) {
      var _this2 = this;

      var componentStack = _ref.componentStack;
      var _this$props = this.props,
          beforeCapture = _this$props.beforeCapture,
          onError = _this$props.onError,
          showDialog = _this$props.showDialog,
          dialogOptions = _this$props.dialogOptions;
      withScope(function (scope) {
        // If on React version >= 17, create stack trace from componentStack param and links
        // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
        // Linking errors requires the `LinkedErrors` integration be enabled.
        // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
        //
        // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
        // with non-error objects. This is why we need to check if the error is an error-like object.
        // See: https://github.com/getsentry/sentry-javascript/issues/6167
        if (isAtLeastReact17(React.version) && isError(error)) {
          var errorBoundaryError = new Error(error.message);
          errorBoundaryError.name = "React ErrorBoundary ".concat(errorBoundaryError.name);
          errorBoundaryError.stack = componentStack; // Using the `LinkedErrors` integration to link the errors together.

          error.cause = errorBoundaryError;
        }

        if (beforeCapture) {
          beforeCapture(scope, error, componentStack);
        }

        var eventId = captureException(error, {
          contexts: {
            react: {
              componentStack: componentStack
            }
          }
        });

        if (onError) {
          onError(error, componentStack, eventId);
        }

        if (showDialog) {
          showReportDialog(_objectSpread(_objectSpread({}, dialogOptions), {}, {
            eventId: eventId
          }));
        } // componentDidCatch is used over getDerivedStateFromError
        // so that componentStack is accessible through state.


        _this2.setState({
          error: error,
          componentStack: componentStack,
          eventId: eventId
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;

      if (onMount) {
        onMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state = this.state,
          error = _this$state.error,
          componentStack = _this$state.componentStack,
          eventId = _this$state.eventId;
      var onUnmount = this.props.onUnmount;

      if (onUnmount) {
        onUnmount(error, componentStack, eventId);
      }
    }
  }, {
    key: "__init2",
    value: function __init2() {
      var _this3 = this;

      this.resetErrorBoundary = function () {
        var onReset = _this3.props.onReset;
        var _this3$state = _this3.state,
            error = _this3$state.error,
            componentStack = _this3$state.componentStack,
            eventId = _this3$state.eventId;

        if (onReset) {
          onReset(error, componentStack, eventId);
        }

        _this3.setState(INITIAL_STATE);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          fallback = _this$props2.fallback,
          children = _this$props2.children;
      var _this$state2 = this.state,
          error = _this$state2.error,
          componentStack = _this$state2.componentStack,
          eventId = _this$state2.eventId;

      if (error) {
        var element = undefined;

        if (typeof fallback === 'function') {
          element = fallback({
            error: error,
            componentStack: componentStack,
            resetError: this.resetErrorBoundary,
            eventId: eventId
          });
        } else {
          element = fallback;
        }

        if (React.isValidElement(element)) {
          return element;
        }

        if (fallback) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('fallback did not produce a valid ReactElement');
        } // Fail gracefully if no fallback provided or is not valid


        return null;
      }

      if (typeof children === 'function') {
        return children();
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(React.Component); // eslint-disable-next-line @typescript-eslint/no-explicit-any


function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
  var _this4 = this;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  var Wrapped = function Wrapped(props) {
    return React.createElement(ErrorBoundary, _objectSpread(_objectSpread({}, errorBoundaryOptions), {}, {
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 173
      }
    }), React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174
      }
    })));
  }; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access


  Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")"); // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over

  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}

export { ErrorBoundary, UNKNOWN_COMPONENT, isAtLeastReact17, withErrorBoundary };